import React, { useEffect, useMemo } from 'react';
import useCommons from 'src/hooks/common/useCommons';
import styled, { css } from 'styled-components';

const TextContainer = styled.div<{}>`
    display: flex;
    justify-content: center;
    padding: 3px 0;
    gap: 6px;
    background: #ffedb1;
    border-radius: 4px;
    min-width: 144px;
    text-align: left;
    width: 80px;
    max-width: 120px;
    font-size: 12px;
    align-self: flex-end;
    margin-bottom: 5px;
    font-weight: 400;
`;

export const DisplayTimeFromPrev: React.FC<{ time: number; resetValue?: () => void }> = ({
    time,
    resetValue,
}) => {
    const { t } = useCommons();

    return (
        <TextContainer>
            <span>{`${time} ${t('timeFromPrevStation')}`}</span>{' '}
        </TextContainer>
    );
};
